module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/main-categories-icons/24-454b63c3189e6ef56234a9a887532df3.svg";